// extracted by mini-css-extract-plugin
export default {"formContainer":"NotFound_formContainer__6EKCI","tipperBottom":"NotFound_tipperBottom__55Srj","not_foundImg":"NotFound_not_foundImg__ZLa2E"};